import { patchRequest } from '@/core';
import { orderTypes } from '@/requests';

export default async function updateOrderTypesRequest(id, patch) {
	let url = orderTypes.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}